import React from "react"
import cx from "classnames"
import { Layout } from "antd"

import styles from "./footer.module.less"

const { Footer } = Layout

const AppFooter = () => (
  <Footer>
    <div className={styles.wrapper}>
      <div className={styles.logoBlock}>
        <div className={styles.logo} />
        <div className={styles.text}>Attendee Reward program<br />Powered by Beeonquest</div>
      </div>
      <div className={styles.contacts}>
        <div className={styles.contact}>
          <div className={styles.locationIcon} />
          <div className={styles.contactText}>1 Yonge st. suite 1801, Toronto, M5E 1W7</div>
        </div>
        <div className={styles.contact}>
          <div className={styles.mailIcon} />
          <a href="mailto:info@beeonquest.com?subject=Request for support" target="_blank" rel="noopener noreferrer" className={styles.contactText}>info@beeonquest.com</a>
        </div>
        <div className={styles.contact}>
          <div className={styles.phoneIcon} />
          <a href="tel:18334048484" className={styles.contactText}>+1-833-404-8484</a>
        </div>
      </div>
      <div className={styles.socials}>
        <div className={styles.facebook} />
        <div className={styles.twitter} />
        <div className={styles.linkedin} />
      </div>
    </div>
    <div className={styles.links}>
      {/* <a href className={styles.text}>Terms and conditions</a>
      <a href className={styles.text}>Privacy policy</a> */}
      <a href="mailto:info@beeonquest.com?subject=Request for support" target="_blank" rel="noopener noreferrer" className={styles.text}>Support</a>
    </div>
    <div className={styles.copyright}>© Beeonquest, 2020</div>
  </Footer>
)

export default AppFooter
